import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ISelect, ITableHeader, ITableRow, IToogleSelect } from '@tecalisdev/infinity';
import { FormService } from '../services/form.service';
import { PaisesService } from '../services/paises.service';
import { TableService } from '../services/table.service';
import { Router } from '@angular/router';
import { XlsxService } from '../services/xlsx.service';
import { MailService } from '../services/mail.service';

import {
	aportaciones,
	dniNieValidator,
	ibanValidator,
	nifSociedadValidator,
	phoneValidator,
	refillDatosAutonomoForm,
	refillDatosForm,
	representations,
	sectores,
	urlValidator,
} from 'src/app/shared/utils/form-utils';

@Component({
	selector: 'app-registration-request',
	templateUrl: './registration-request.component.html',
	styleUrls: ['./registration-request.component.scss'],
})
export class RegistrationRequestComponent implements OnInit {
	registratonType!: string;
	steps = [
		{ label: 'Datos', selected: true, id: 1 },
		{ label: 'Promoción', selected: false, id: 2 },
		{ label: 'Tienda', selected: false, id: 3 },
	];
	step: number = 1;
	isClickedSoc: boolean = false;
	isClickedAut: boolean = false;
	isClickedSi: boolean = false;
	isClickedNo: boolean = true;
	showFirstPercent: boolean = false;
	showSecondPercent: boolean = false;
	showThirdPercent: boolean = false;
	showFixedAmount: boolean = false;
	paises: ISelect[] = [{ id: 1, label: 'España' }];
	provincias: ISelect[] = this.paisesService.getProvincias();
	sectores: ISelect[] = sectores();
	representations: ISelect[] = representations();
	aportaciones: ISelect[] = aportaciones();
	public businessTypeOptions: Array<IToogleSelect> = [
		{ id: 'sociedad', label: 'Sociedad' },
		{ id: 'autonomo', label: 'Autónomo' },
	];
	public businessTypeOptionSelected?: IToogleSelect;
	public returnsAllowedOptions: Array<IToogleSelect> = [
		{ id: 'si', label: 'Sí' },
		{ id: 'no', label: 'No' },
	];
	public returnsAllowedOptionSelected?: IToogleSelect;

	datosForm!: FormGroup;
	modalForm!: FormGroup;
	modalShopForm!: FormGroup;
	importShops!: FormGroup;
	step2Form!: FormGroup;
	step3Form!: FormGroup;

	headers: ITableHeader[] = [];
	headersShop: ITableHeader[] = [];
	rows: ITableRow[] = [];
	rowsShops: ITableRow[] = [];
	modalVisible: boolean = false;
	modalAddShop: boolean = false;
	modalAddShopMassive: boolean = false;
	rowIndex!: number | undefined;
	rowIndexShop!: number | undefined;
	showMancomunados: boolean = false;
	showSnack: boolean = false;

	buttonLabel: string = 'Volver atrás';
	aportSelected: boolean = false;
	base64Logo: string = '';
	exitModal: boolean = false;

	constructor(
		private readonly location: Location,
		private fb: FormBuilder,
		public formService: FormService,
		private paisesService: PaisesService,
		private tableService: TableService,
		private router: Router,
		private xlsx: XlsxService,
		private mailService: MailService,
		@Inject(DOCUMENT) private document: Document,
	) {
		this.datosForm = this.fb.group({
			businessType: ['', Validators.required],
			pais: ['', Validators.required],
			nombreComercio: ['', Validators.required],
			web: ['', [Validators.required, urlValidator()]],
			sector: ['', Validators.required],
			actividad: ['', Validators.required],
			hosteleriaAdherido: [''],
			volvemosAdherido: [''],
			nifSociedad: [''],
			razonSocSociedad: [''],
			emailSociedad: [''],
			representacionSociedad: [''],
			inscripcionSociedad: [''],
			emailFacturacion: [''],
			nombreRepresentante: [''],
			dniRepresentante: [''],
			emailRepresentante: [''],
			telefonoProfesionalRepresentante: [''],
			escritura: [''],
			nombreAutonomo: [''],
			dniAutonomo: [''],
			razonSocAutonomo: [''],
			emailProfesional: [''],
			telefonoProfesional: [''],
			direccionFiscal: [''],
			nombreDeudor: ['', Validators.required],
			direccionDeudor: ['', Validators.required],
			codigoPostalDeudor: ['', Validators.required],
			poblacionDeudor: ['', Validators.required],
			provinciaDeudor: ['', Validators.required],
			paisDeudor: ['', Validators.required],
			mancomunados: [''],
			SWIFT: ['', Validators.required],
			IBAN: ['', [Validators.required, ibanValidator()]],
			localidadFirma: ['', Validators.required],
			logotipo: ['', Validators.required],
		});

		this.modalForm = this.fb.group({
			nombre: ['', Validators.required],
			dni: ['', [Validators.required, dniNieValidator()]],
			email: ['', [Validators.required, Validators.email]],
			telefonoMancomunado: ['', [Validators.required, phoneValidator()]],
		});

		this.step2Form = this.fb.group({
			returnsAllowed: ['', Validators.required],
			plazoDevolucion: [''],
			tipoAportacion: ['', Validators.required],
			aportacionCompra: ['', [Validators.required, Validators.min(1)]],
			aportacionImporteFijo: [''],
			aportacionCompraMinimoTicket: [''],
			aportacionCompraMaximoTicket: [''],
		});

		this.step3Form = this.fb.group({
			urlWebVenta: [''],
			tpvOnline: [''],
			emailContactoWebVenta: [''],
			shops: [''],
		});

		this.modalShopForm = this.fb.group({
			nombreEstablecimiento: ['', Validators.required],
			emailEstablecimiento: ['', [Validators.required, Validators.email]],
			direccionEstablecimiento: ['', Validators.required],
			PoblacionEstablecimiento: ['', Validators.required],
			provinciaEstablecimiento: ['', Validators.required],
			cpEstablecimiento: ['', Validators.required],
		});

		this.importShops = this.fb.group({
			file: [''],
		});

		this.headers = this.tableService.getHeaders('mancomunados');
		this.headersShop = this.tableService.getHeaders('shops');
	}

	ngOnInit(): void {
		const datos = this.formService.getForm();
		if (!datos.channel) this.router.navigate(['/start']);

		const option = Number(this.location.path().split('/')[2]);
		this.registratonType = option === 0 ? 'CANAL ONLINE' : option === 1 ? 'CANAL FÍSICO' : 'CANAL ONLINE Y FÍSICO';

		this.paisesService.getPaises().subscribe({
			next: (paises) => {
				this.paises = paises
					.map((pais: any, index: number) => ({ id: index, label: pais.name.common }))
					.sort((a: any, b: any) => {
						return a.label.localeCompare(b.label, 'es');
					});
			},
			error: () => {},
		});

		if (datos.businessType) {
			const { businessType, returnsAllowed } = datos;

			// Step1
			// Poner el "Tipo de negocio"
			this.changeClass({ label: businessType });

			if (businessType === 'Sociedad' || businessType === 'Autónomo') {
				this.step = datos.tab!;
				this.steps = this.steps.map((item) =>
					item.id === datos.tab! ? { ...item, selected: true } : { ...item, selected: false },
				);

				this.datosForm.patchValue({ ...datos });

				if (datos.logotipo) this.convertToBase64(datos.logotipo);
			}

			// Mostrar apartado de "Mancomunados"
			if (datos.tipoAportacion) this.valueChange(datos.representacionSociedad);

			if (businessType === 'Sociedad' && datos.mancomunados && datos.mancomunados.length > 0) {
				datos.mancomunados.forEach((mancomunado) => {
					this.addMancomunadoRow(
						mancomunado.nombre,
						mancomunado.dni,
						mancomunado.email,
						mancomunado.telefonoMancomunado,
					);
				});
				this.datosForm.get('mancomunados').setValue(this.rows);
				this.showMancomunados = true;
			}

			this.isClickedSoc = businessType === 'Sociedad';
			this.isClickedAut = businessType === 'Autónomo';

			// Forms comunes a ambos
			// Step2
			this.step2Form.patchValue({
				plazoDevolucion: datos.plazoDevolucion ?? '',
				tipoAportacion: datos.tipoAportacion,
				aportacionCompra: datos.aportacionCompra,
				aportacionImporteFijo: datos.aportacionImporteFijo,
				aportacionCompraMinimoTicket: datos.aportacionCompraMinimoTicket,
				aportacionCompraMaximoTicket: datos.aportacionCompraMaximoTicket,
			});

			// Mostrar input/s de "Porcentaje de aportación"
			if (datos.tipoAportacion) this.valueChange(datos.tipoAportacion);

			// Poner el "¿Se permiten devoluciones?"
			this.allowReturn({ id: returnsAllowed });

			// Step3
			this.step3Form.patchValue({
				urlWebVenta: datos.channel?.includes('ONLINE') ? datos.urlWebVenta : '',
				tpvOnline:
					datos.channel?.includes('ONLINE') && datos.channelBoth && datos.channelBoth === 'AMBOS'
						? datos.tpvOnline
						: '',
				emailContactoWebVenta: datos.channel?.includes('ONLINE') ? datos.emailContactoWebVenta : '',
			});

			if (datos.channel?.includes('FISICO')) {
				if (datos.shops && datos.shops.length > 0) {
					this.rowsShops = datos.shops;
				}
			}
		}
	}

	public clickEvent(event: any): void {
		const newStep = event.id;

		// Comprobar si el formulario actual y el anterior son válidos
		if (newStep >= 2 && this.datosForm.invalid) return;
		if (newStep === 3 && this.step2Form.invalid) return;

		if (this.datosForm.valid) {
			this.steps = this.steps.map((item) =>
				item.id === event.id ? { ...item, selected: true } : { ...item, selected: false },
			);
			this.step = this.steps.find((item) => item.selected)!.id;

			this.scrollToTop();
		} else this.datosForm.markAllAsTouched();
	}

	private scrollToTop(): void {
		const scrollable = this.document.querySelector('.content__container');
		scrollable?.scrollTo({ top: 0, behavior: 'smooth' });
	}

	public allowReturn(event: any): void {
		if (!event.id) return;

		const { id } = event;
		this.step2Form.get('returnsAllowed').setValue(id);
		this.formService.setForm({ returnsAllowed: id });

		this.returnsAllowedOptionSelected = this.returnsAllowedOptions.find((opt) => opt.id === id);

		this.isClickedSi = id === 'si';
		this.isClickedNo = id === 'no';

		// Añadir validador de required si ha pulsado en "Sí"
		const control = this.step2Form.get('plazoDevolucion');
		if (control) {
			if (this.isClickedSi)
				control.setValidators([Validators.required, Validators.pattern(/^\d+$/), Validators.min(1)]);
			else control.clearValidators();
			control.updateValueAndValidity({ onlySelf: true });
			this.step2Form.updateValueAndValidity();
		}
	}

	public buttonAction(option: string | number): void {
		if (option === 'BACK') {
			if (this.step === 1) {
				this.exitModal = true;
			} else if (this.step === 2 || this.step === 3) {
				this.step--;
				this.clickEvent({ id: this.step });
			}
			return;
		}

		//validate step 1
		if (this.step === 1) {
			if (this.datosForm.valid) {
				// Si es sociedad, tiene showMancomunados a true y no ha añadido ninguno,
				// no permitir continuar con el siguiente step
				if (this.isClickedSoc && this.showMancomunados && this.rows.length === 0) return;

				option === 'BACK' ? this.location.back() : Number(option) ? (this.step = Number(option)) : null;
				if (Number(option) && Number(option) <= 3) this.clickEvent({ id: Number(option) });

				const datos = this.datosForm.getRawValue();
				this.formService.setForm(datos);

				if (datos.escritura) this.mailService.convertToBase64(datos.escritura[0], 'escritura');
				else this.mailService.clearBase64Escritura();

				if (datos.logotipo) this.mailService.convertToBase64(datos.logotipo[0], 'logo');
				else this.mailService.clearBase64Logo();

				if (this.isClickedSoc && this.rows.length > 0) {
					this.formService.setForm({
						mancomunados: this.rows.map((row: any) => {
							return {
								nombre: row.cells[0].label,
								dni: row.cells[1].label,
								email: row.cells[2].label,
								telefonoMancomunado: row.cells[3].label,
							};
						}),
					});
				}
			} else {
				this.datosForm.markAllAsTouched();
			}
		}

		//validate step 2
		else if (this.step === 2) {
			if (this.step2Form.valid) {
				// Comprobar si ha seleccionado una opción para la "Política de devoluciones"
				if (!this.returnsAllowedOptionSelected) return;

				// Si la opción de "Política de devoluciones" es sí, necesita un "plazoDevolucion"
				if (
					this.returnsAllowedOptions[0].id === this.returnsAllowedOptionSelected.id &&
					!this.step2Form.get('plazoDevolucion').value?.trim()
				) {
					return;
				}

				//setear validadores a step 3
				if (
					this.formService.getForm()?.channel?.includes('ONLINE') ||
					this.formService.getForm()?.channelBoth === 'AMBOS'
				) {
					this.step3Form.get('urlWebVenta')?.setValidators([Validators.required, urlValidator()]);
					this.step3Form.get('emailContactoWebVenta')?.setValidators([Validators.required, Validators.email]);
				} else {
					this.step3Form.get('urlWebVenta')?.clearValidators();
					this.step3Form.get('emailContactoWebVenta')?.clearValidators();
				}

				if (this.formService.getForm()?.channelBoth === 'ONLINE') {
					this.step3Form.get('tpvOnline')?.setValidators([Validators.required]);
				} else {
					this.step3Form.get('tpvOnline')?.clearValidators();
				}

				if (
					this.formService.getForm()?.channel?.includes('FISICO') &&
					(this.formService.getForm()?.channelBoth === 'AMBOS' ||
						this.formService.getForm()?.channelBoth === undefined)
				) {
					this.step3Form.get('shops')?.setValidators([Validators.required]);
					if (this.rowsShops) this.step3Form.get('shops')?.setValue(this.rowsShops);
				} else {
					this.step3Form.get('shops')?.clearValidators();
				}

				this.step3Form.get('urlWebVenta')?.updateValueAndValidity({ onlySelf: true });
				this.step3Form.get('emailContactoWebVenta')?.updateValueAndValidity({ onlySelf: true });
				this.step3Form.get('tpvOnline')?.updateValueAndValidity({ onlySelf: true });
				this.step3Form.get('shops')?.updateValueAndValidity({ onlySelf: true });
				this.step3Form.updateValueAndValidity();

				option === 'BACK' ? this.location.back() : Number(option) ? (this.step = Number(option)) : null;
				if (Number(option) && Number(option) <= 3) this.clickEvent({ id: Number(option) });
				if (Number(option) === 3) {
					if (this.isClickedNo) this.step2Form.get('plazoDevolucion')?.patchValue('');
					this.formService.setForm(this.step2Form.getRawValue());
				}
			} else {
				this.step2Form.markAllAsTouched();
			}
		}

		//validate step 3
		else if (this.step === 3) {
			if (this.step3Form.valid) {
				// Comprobar si es "FISICO" y tiene establecimientos
				if (
					!this.formService.getForm().channelBoth?.includes('ONLINE') &&
					this.formService.getForm().channel?.includes('FISICO') &&
					this.rowsShops.length === 0
				) {
					return;
				}

				option === 'BACK' ? this.location.back() : Number(option) ? (this.step = Number(option)) : null;
				if (Number(option) && Number(option) <= 3) this.clickEvent({ id: Number(option) });

				if (Number(option) === 4) {
					this.formService.setForm(this.step3Form.getRawValue());
					if (this.rowsShops.length !== 0) this.formService.setForm({ shops: this.rowsShops });
					this.router.navigate(['/resume']);
				}
			} else {
				this.step3Form.markAllAsTouched();
			}
		}
	}

	addMancomunado() {
		this.modalVisible = true;
	}

	closeDialogExitModalEdit(event: any) {
		switch (event) {
			//Salir
			case 'buttonPrimary':
				this.exitModal = false;
				this.formService.resetForm(), this.router.navigate(['/']);
				break;
			//Cancelar
			case 'buttonSecondary':
				this.exitModal = false;
				break;
			//Cerrar
			default:
				this.exitModal = false;
				break;
		}
	}

	addMancomunadoRow(nombre: string, dni: string, email: string, telefonoMancomunado: string) {
		this.rows.push({
			clickValue: '',
			cells: [
				{
					label: nombre,
				},
				{
					label: dni,
				},
				{
					label: email,
				},
				{
					label: telefonoMancomunado,
				},
				{
					align: 'right',
					label: '',
					buttonIcon: {
						id: 'button2dropdown',
						icon: 'icon-more',
						menu: [
							{
								label: 'Editar',
								icon: 'icon-edit',
								id: 'option0',
							},
							{
								label: 'Eliminar',
								style: 'red',
								icon: 'icon-trash',
								id: 'option1',
								divider: true,
							},
						],
					},
				},
			],
		});
	}

	closeDialogModalEdit(event: any) {
		switch (event) {
			//Guardar
			case 'buttonPrimary':
				if (!!this.modalForm.valid) {
					const { nombre, dni, email, telefonoMancomunado } = this.modalForm.getRawValue();
					if (!this.rowIndex && isNaN(this.rowIndex!))
						this.addMancomunadoRow(nombre, dni, email, telefonoMancomunado);
					else {
						this.rows[this.rowIndex!].cells[0].label = nombre;
						this.rows[this.rowIndex!].cells[1].label = dni;
						this.rows[this.rowIndex!].cells[2].label = email;
						this.rows[this.rowIndex!].cells[3].label = telefonoMancomunado;

						this.rowIndex = undefined;
					}

					this.datosForm.get('mancomunados').setValue(this.rows);
					this.modalForm.reset();
					this.modalVisible = false;
				} else {
					this.modalForm.markAllAsTouched();
				}
				break;
			//Cancelar
			case 'buttonSecondary':
				this.modalVisible = false;
				break;
			//Cerrar
			default:
				this.modalVisible = false;
				break;
		}
	}

	getMenu(event: any, type: string) {
		if (type === 'mancomunado') {
			if (event?.cellId?.label === 'Editar') {
				this.modalVisible = true;
				this.rowIndex = event.rowIndex;
				const rowSelected = this.rows[this.rowIndex!].cells;
				const params = ['nombre', 'dni', 'email', 'telefonoMancomunado'];

				rowSelected.forEach((cell, index) => {
					this.modalForm.get(params[index])?.patchValue(cell.label);
				});
			}
			if (event?.cellId.label === 'Eliminar') {
				this.rows.splice(event.rowIndex, 1);
				this.datosForm.get('mancomunados').setValue(this.rows);
			}
		}

		if (type === 'shop') {
			if (event?.cellId?.label === 'Editar') {
				this.modalAddShop = true;
				this.rowIndexShop = event.rowIndex;
				const rowSelected = this.rowsShops[this.rowIndexShop!].cells;
				const params = [
					'nombreEstablecimiento',
					'emailEstablecimiento',
					'direccionEstablecimiento',
					'PoblacionEstablecimiento',
					'provinciaEstablecimiento',
					'cpEstablecimiento',
				];

				rowSelected.forEach((cell, index) => {
					// Buscar la provincia correspondiente y asignarla a provinciaEstablecimiento del formulario
					if (index === 4) {
						const provincia = this.provincias.find((p) => p.label === cell.label);
						if (provincia) this.modalShopForm.get(params[index])?.patchValue(provincia);
					} else {
						this.modalShopForm.get(params[index])?.patchValue(cell.label);
					}
				});
			}
			if (event?.cellId.label === 'Duplicar') {
				const index = event.rowIndex;
				if (Number.isNaN(index) || index < 0) return;

				const originalItem = this.rowsShops[index];
				let duplicatedItem;

				if (typeof structuredClone === 'function') {
					duplicatedItem = structuredClone(originalItem);
				} else {
					duplicatedItem = JSON.parse(JSON.stringify(originalItem));
				}

				if (!duplicatedItem) return;
				// Insertar después del original
				this.rowsShops.splice(index + 1, 0, duplicatedItem);

				this.step3Form.get('shops')?.setValue(this.rowsShops);
			}
			if (event?.cellId.label === 'Eliminar') {
				this.rowsShops.splice(event.rowIndex, 1);
				this.step3Form.get('shops')?.setValue(this.rowsShops);
			}
		}
	}

	public changeClass(event: any): void {
		if (!event.label) return;

		const { label } = event;
		this.datosForm.get('businessType').setValue(label);
		this.formService.setForm({ businessType: label });

		this.businessTypeOptionSelected = this.businessTypeOptions.find((opt) => opt.label === label);

		if (label) this.sectores = sectores(label);

		if (label === 'Sociedad') {
			this.isClickedSoc = true;
			this.isClickedAut = false;
			//Clear validators autonomo
			this.clearValidators([
				'nombreAutonomo',
				'dniAutonomo',
				'razonSocAutonomo',
				'emailProfesional',
				'telefonoProfesional',
				'direccionFiscal',
			]);

			this.addValidators([
				'nifSociedad',
				'razonSocSociedad',
				'emailSociedad',
				'representacionSociedad',
				'inscripcionSociedad',
				'emailFacturacion',
				'nombreRepresentante',
				'dniRepresentante',
				'emailRepresentante',
				'telefonoProfesionalRepresentante',
				'escritura',
			]);
		}
		if (label === 'Autónomo') {
			this.isClickedSoc = false;
			this.isClickedAut = true;
			//Clear validators sociedad
			this.clearValidators([
				'nifSociedad',
				'razonSocSociedad',
				'emailSociedad',
				'representacionSociedad',
				'inscripcionSociedad',
				'emailFacturacion',
				'nombreRepresentante',
				'dniRepresentante',
				'emailRepresentante',
				'telefonoProfesionalRepresentante',
				'escritura',
			]);

			// Eliminar el valor de escritura para evitar enviarlo por email
			this.datosForm.patchValue({ escritura: undefined });

			this.addValidators([
				'nombreAutonomo',
				'dniAutonomo',
				'razonSocAutonomo',
				'emailProfesional',
				'telefonoProfesional',
				'direccionFiscal',
			]);
		}
	}

	clearValidators(keys: any) {
		keys.forEach((key: string) => {
			const control = this.datosForm.get(key);
			if (control) {
				control.clearValidators();
				control.updateValueAndValidity();
			}
		});
		this.datosForm.updateValueAndValidity();
	}

	addValidators(keys: any) {
		keys.forEach((key: string) => {
			let control = this.datosForm.get(key);
			if (control) {
				if (key === 'dniAutonomo' || key === 'dniRepresentante') {
					control.setValidators([Validators.required, dniNieValidator()]);
				} else if (
					key === 'emailProfesional' ||
					key === 'emailSociedad' ||
					key === 'emailFacturacion' ||
					key === 'emailRepresentante'
				) {
					control.setValidators([Validators.required, Validators.email]);
				} else if (key === 'telefonoProfesional' || key === 'telefonoProfesionalRepresentante') {
					control.setValidators([Validators.required, phoneValidator()]);
				} else if (key === 'nifSociedad') {
					control.setValidators([Validators.required, nifSociedadValidator()]);
				} else {
					control.setValidators([Validators.required]);
				}
				control.updateValueAndValidity({ onlySelf: true });
			}
		});
		this.datosForm.updateValueAndValidity();
	}

	public valueChange(event: any): void {
		if (event.id === 'porcentaje_compra') {
			this.aportSelected = true;
			this.showFirstPercent = true;
			this.showSecondPercent = false;
			this.showThirdPercent = false;
			this.showFixedAmount = false;
			this.step2Form.get('aportacionCompra')?.setValidators([Validators.required, Validators.min(1)]);
			this.step2Form.get('aportacionCompra')?.updateValueAndValidity({ onlySelf: true });
			this.step2Form.get('aportacionImporteFijo')?.clearValidators();
			this.step2Form.get('aportacionImporteFijo')?.updateValueAndValidity({ onlySelf: true });
			this.handleTipoAportacionValidators(event.id);
		} else if (event.id === 'porcentaje_compra_minimo') {
			this.aportSelected = true;
			this.showSecondPercent = true;
			this.showFirstPercent = false;
			this.showThirdPercent = false;
			this.showFixedAmount = false;
			this.step2Form.get('aportacionCompra')?.setValidators([Validators.required, Validators.min(1)]);
			this.step2Form.get('aportacionCompra')?.updateValueAndValidity({ onlySelf: true });
			this.step2Form.get('aportacionImporteFijo')?.clearValidators();
			this.step2Form.get('aportacionImporteFijo')?.updateValueAndValidity({ onlySelf: true });
			this.handleTipoAportacionValidators(event.id);
		} else if (event.id === 'porcentaje_compra_maximo') {
			this.aportSelected = true;
			this.showThirdPercent = true;
			this.showFirstPercent = false;
			this.showSecondPercent = false;
			this.showFixedAmount = false;
			this.step2Form.get('aportacionCompra')?.setValidators([Validators.required, Validators.min(1)]);
			this.step2Form.get('aportacionCompra')?.updateValueAndValidity({ onlySelf: true });
			this.step2Form.get('aportacionImporteFijo')?.clearValidators();
			this.step2Form.get('aportacionImporteFijo')?.updateValueAndValidity({ onlySelf: true });
			this.handleTipoAportacionValidators(event.id);
		} else if (event.id === 'porcentaje_compra_minimo_maximo') {
			this.aportSelected = true;
			this.showSecondPercent = true;
			this.showThirdPercent = true;
			this.showFirstPercent = false;
			this.showFixedAmount = false;
			this.step2Form.get('aportacionCompra')?.setValidators([Validators.required, Validators.min(1)]);
			this.step2Form.get('aportacionCompra')?.updateValueAndValidity({ onlySelf: true });
			this.step2Form.get('aportacionImporteFijo')?.clearValidators();
			this.step2Form.get('aportacionImporteFijo')?.updateValueAndValidity({ onlySelf: true });
			this.handleTipoAportacionValidators(event.id);
		} else if (event.id === 'importe_fijo_compra') {
			this.aportSelected = false;
			this.showFirstPercent = false;
			this.showSecondPercent = false;
			this.showThirdPercent = false;
			this.showFixedAmount = true;
			this.step2Form.get('aportacionCompra')?.clearValidators();
			this.step2Form.get('aportacionCompra')?.updateValueAndValidity({ onlySelf: true });
			this.step2Form.get('aportacionImporteFijo')?.setValidators([Validators.required, Validators.min(0.01)]);
			this.step2Form.get('aportacionImporteFijo')?.updateValueAndValidity({ onlySelf: true });
			this.handleTipoAportacionValidators(event.id);
		} else if (event.id === 'Mancomunado') {
			this.showMancomunados = true;
			this.datosForm.get('mancomunados')?.setValidators([Validators.required]);
			this.datosForm.get('mancomunados')?.updateValueAndValidity({ onlySelf: true });
			this.datosForm.updateValueAndValidity();
		} else {
			this.showMancomunados = false;
			this.datosForm.get('mancomunados')?.clearValidators();
			this.datosForm.get('mancomunados')?.updateValueAndValidity({ onlySelf: true });
			this.datosForm.updateValueAndValidity();
		}
	}

	private handleTipoAportacionValidators(type: string): void {
		const controlMinimo = this.step2Form.get('aportacionCompraMinimoTicket');
		const controlMaximo = this.step2Form.get('aportacionCompraMaximoTicket');

		// Mínimo
		if (type === 'porcentaje_compra_minimo' || type === 'porcentaje_compra_minimo_maximo') {
			controlMinimo.addValidators([Validators.required]);
		} else {
			controlMinimo.clearValidators();
		}
		controlMinimo.updateValueAndValidity({ onlySelf: true });

		// Máximo
		if (type === 'porcentaje_compra_maximo' || type === 'porcentaje_compra_minimo_maximo') {
			controlMaximo.addValidators([Validators.required]);
		} else {
			controlMaximo.clearValidators();
		}
		controlMaximo.updateValueAndValidity({ onlySelf: true });

		this.step2Form.updateValueAndValidity();
	}

	valueChangeCheck(val: boolean) {}

	actions(event: any) {
		if (event === 'add') {
			this.modalAddShop = true;
		}
		if (event === 'importar') {
			this.modalAddShopMassive = true;
		}
	}

	closeModalShop(event: any) {
		switch (event) {
			//Guardar
			case 'buttonPrimary':
				if (!!this.modalShopForm.valid) {
					const {
						nombreEstablecimiento,
						emailEstablecimiento,
						direccionEstablecimiento,
						PoblacionEstablecimiento,
						provinciaEstablecimiento,
						cpEstablecimiento,
					} = this.modalShopForm.getRawValue();
					if (!this.rowIndexShop && isNaN(this.rowIndexShop!))
						this.rowsShops.push({
							clickValue: '',
							cells: [
								{
									label: nombreEstablecimiento,
								},
								{
									label: emailEstablecimiento,
								},
								{
									label: direccionEstablecimiento,
								},
								{
									label: PoblacionEstablecimiento,
								},
								{
									label: provinciaEstablecimiento.label,
								},
								{
									label: cpEstablecimiento,
								},
								{
									align: 'right',
									label: '',
									buttonIcon: {
										id: 'button2dropdown',
										icon: 'icon-more',
										menu: [
											{
												label: 'Editar',
												icon: 'icon-edit',
												id: 'option0',
											},
											{
												label: 'Duplicar',
												icon: 'icon-copy',
												id: 'option1',
											},
											{
												label: 'Eliminar',
												style: 'red',
												icon: 'icon-trash',
												id: 'option2',
												divider: true,
											},
										],
									},
								},
							],
						});
					else {
						this.rowsShops[this.rowIndexShop!].cells[0].label = nombreEstablecimiento;
						this.rowsShops[this.rowIndexShop!].cells[1].label = emailEstablecimiento;
						this.rowsShops[this.rowIndexShop!].cells[2].label = direccionEstablecimiento;
						this.rowsShops[this.rowIndexShop!].cells[3].label = PoblacionEstablecimiento;
						this.rowsShops[this.rowIndexShop!].cells[4].label = provinciaEstablecimiento.label;
						this.rowsShops[this.rowIndexShop!].cells[5].label = cpEstablecimiento;

						this.rowIndexShop = undefined;
					}

					this.modalShopForm.reset();
					this.modalAddShop = false;
					this.showSnack = true;
					setTimeout(() => {
						this.showSnack = false;
					}, 2000);
				} else {
					this.modalShopForm.markAllAsTouched();
				}
				break;
			//Cancelar
			case 'buttonSecondary':
				this.modalShopForm.reset();
				this.modalAddShop = false;
				this.rowIndexShop = undefined;
				break;
			//Cerrar
			default:
				this.modalShopForm.reset();
				this.modalAddShop = false;
				this.rowIndexShop = undefined;
				break;
		}

		this.step3Form.get('shops')?.setValue(this.rowsShops);
	}

	closeModalShopMassive(event: any) {
		switch (event) {
			//Guardar
			case 'buttonPrimary':
				this.modalAddShopMassive = false;
				break;
			//Cancelar
			case 'buttonSecondary':
				this.modalAddShopMassive = false;
				break;
			//Cerrar
			default:
				this.modalAddShopMassive = false;
				break;
		}

		this.step3Form.get('shops')?.setValue(this.rowsShops);
	}

	public fileSelected(file: FileList): void {
		if (!file || file.length === 0) return;

		try {
			this.xlsx.readFile(file[0]);
		} catch (_) {
			this.handleFileSelectedError();
		}

		this.xlsx.getFileData().subscribe({
			next: (data) => {
				if (!data) {
					this.handleFileSelectedError();
					this.rowsShops = [];
					this.step3Form.get('shops')?.setValue(this.rowsShops);
					return;
				}

				this.importShops.get('file').setErrors(null);
				this.rowsShops = data;
				this.step3Form.get('shops')?.setValue(this.rowsShops);
				this.modalAddShopMassive = false;
				this.showSnack = true;
				setTimeout(() => {
					this.showSnack = false;
				}, 2000);
			},
			error: () => {
				this.handleFileSelectedError();
				this.rowsShops = [];
				this.step3Form.get('shops')?.setValue(this.rowsShops);
			},
		});
	}

	private handleFileSelectedError(): void {
		this.importShops.get('file').setValue(null);
		this.importShops.get('file').setErrors({ invalid: true });
	}

	toolbarActions(event: any) {
		if (event?.label === 'Añadir') this.modalAddShop = true;
		if (event?.id === 'upload') this.modalAddShopMassive = true;
	}

	downloadTemplate() {
		this.xlsx.generateTemplate();
	}

	convertToBase64(file: any): void {
		if (!file || file.length === 0 || !(file[0] instanceof File)) return;

		const reader = new FileReader();

		reader.onload = () => {
			this.base64Logo = reader.result as string;
		};

		reader.readAsDataURL(file[0]);
	}

	removeLogo() {
		this.base64Logo = '';
		this.datosForm.controls['logotipo'].setValue('');
	}

	public editLogo(logo: File | null): void {
		if (!logo) this.removeLogo();
		else {
			const fileList = new DataTransfer();
			fileList.items.add(logo);
			this.datosForm.controls['logotipo'].setValue(fileList.files);

			this.convertToBase64([logo]);
		}
	}
}
